export const ConsumerNetIncomeViewUat = {
  title: 'consumerNetIncome.title',
}
